// @ts-nocheck
import axios from 'axios';

export interface IRes {
    success: boolean;
    message: string;
    code: number;
    data: any;
}

// 设置默认的请求头，从 localStorage 中获取 cookie
axios.defaults.headers.common['Cookie'] = localStorage.getItem('cookie') || '';

// 添加请求拦截器
axios.interceptors.request.use((config) => {
    config.headers.Cookie = localStorage.getItem('cookie') || '';
    return config;
}, (error) => {
    return Promise.reject(error);
});

function handleAuthExpired() {
    localStorage.removeItem('user');
    localStorage.removeItem('cookie');
    if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
    }
}

// 添加响应拦截器：处理鉴权失败
axios.interceptors.response.use(
    (response) => {
        const data = response.data;
        // 后端 JSON 返回 code 表示未登录
        if (data && typeof data === 'object' && (data.code === 401 || data.code === 403)) {
            handleAuthExpired();
            return response;
        }
        // 302 跟随后返回的不是标准 API 格式
        if (data && typeof data === 'object' && data.code === undefined && response.config.url && !response.config.url.includes('/login')) {
            handleAuthExpired();
            return response;
        }
        // 字符串类型的 HTML 响应（302 跟随后）
        if (typeof data === 'string' && (data.includes('<html') || data.includes('<!doctype') || data.includes('<!DOCTYPE'))) {
            handleAuthExpired();
        }
        return response;
    },
    (error) => {
        if (error.response) {
            const status = error.response.status;
            if (status === 401 || status === 403) {
                handleAuthExpired();
                return Promise.reject(error);
            }
        }
        // CORS 错误 / 网络错误：302 重定向到跨域地址时浏览器会报 CORS 错误
        // 此时 error.response 为空，error.message 包含 "Network Error"
        if (!error.response && error.message && (
            error.message.includes('Network Error') ||
            error.message.includes('CORS') ||
            error.message.includes('cors')
        )) {
            // 如果当前已登录状态遇到网络错误，大概率是 session 过期 302 导致的
            if (localStorage.getItem('cookie')) {
                handleAuthExpired();
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }
);

const host = '';

function nw(type: string, api: string, params: {}, options: { showError?: boolean } = {}) {
    // Prevent browser caching on GET/DELETE requests
    let finalParams = params;
    if (type === 'get' || type === 'delete') {
        finalParams = { ...params, _t: Date.now() };
    }
    const ajaxParams = type === 'get' || type === 'delete' ? { params: finalParams } : finalParams;

    return axios[type](`${host}${api}`, ajaxParams, {
        withCredentials: true,
    }).then((res: IRes) => {
        const response = res.data;

        // 如果响应不是标准 API 格式（没有 code 字段），说明被 302 了
        if (!response || typeof response !== 'object' || response.code === undefined) {
            handleAuthExpired();
            return { success: false, message: '登录已过期', code: 401, data: null };
        }

        const { success } = response;
        if (!success && options.showError !== false) {
            const { message } = { ...response };
            console.log('axios-error', message);
        }

        return res.data;
    }).catch((e: any) => {
        // catch 里不再重复处理，拦截器已处理
        // 但如果拦截器没处理到（比如 nw 自己的 then 抛出的），兜底处理
        if (e instanceof Error) {
            return {
                success: false,
                message: e.message,
            };
        }
        return { success: false };
    });
}

const factory = (type: string) => (api: string, params?: {}, options?: {}) => nw(type, api, { ...params }, options || {});
const get = factory('get');
const post = factory('post');
const put = factory('put');
const del = factory('delete');

export {
    get,
    post,
    put,
    del,
};
